module.exports = __webpack_public_path__ + "static/media/40-10.182893e6.mp3";